export default __webpack_public_path__ + "static/media/galleryImage1.02f25a67.jpg";